import { VBC_API_GATEWAY } from '@/api/index';
const API_VERSION = 'v1';

export async function createSession(idToken: string, extensionId: string, extensionNumber: string) {
  const response = await VBC_API_GATEWAY.post(`/ms-teams/api/${API_VERSION}/sessions`, {
    id_token: idToken,
    extension_id: extensionId,
    extension_number: extensionNumber,
  });
  return response.data;
}

export async function endSession(sessionId: string) {
  try {
    await VBC_API_GATEWAY.delete(`/ms-teams/api/${API_VERSION}/sessions/${sessionId}`);
  } catch (e) {
    // endSession may return a 404 error, this happens when another Teams user logged in to a VBC user that already has a session and "stole" it (with a new ID).
    console.error(e);
    if (e.response && e.response.status === 404) {
      return;
    }
    throw e;
  }
}
